import React, {useEffect, useState, useRef} from "react";
import {xcService} from "../../../_services/xcService";
import {useTranslation, withTranslation} from "react-i18next";
import {Avatar, Badge, List} from 'antd';
import {Select, Spin,Space, Popconfirm} from 'antd';
import {Typography} from 'antd';
import {Input} from 'antd';
import {isBrowser} from 'react-device-detect';

import {
    LeftOutlined,
    DeleteOutlined,
    SendOutlined,LoadingOutlined,
    FormOutlined
} from "@ant-design/icons";
import * as _ from 'lodash';
import {Button} from "antd";
import moment from "moment";
import Message from "./message";
import {v1 as uuidv1} from "uuid";
import variables from "../../../_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";
import { Radio } from 'antd';
import config from "_config/config.js";
import { io } from "socket.io-client";
import { concatName, concatNameOrAnon, getNameByProfile, isUUID } from "_helpers";

const { TextArea } = Input;

const {Option}=Select;

const MessageUserView = () => {
    const {t, i18n} = useTranslation();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const [loading, setLoading ] = useState(false);
    const [messagesData, setMessagesData] = useState([]);
    const [groupMessagesData, setGroupMessagesData] = useState([]);
    const [listChats, setListChats] = useState([]);
    const [chatSel, setChatSel] = useState(null);
    const [lastComment, setLastComment] = useState(null);
    const [messages, setMessages] = useState([]);
    const [tutors, setTutors] = useState([]);
    const [tutorSel, setTutorSel] = useState(null);
    const [writing, setWriting] = useState(false);
    const userStorage = JSON.parse(storage.getItem(variables.USER));
    const [userData, setUserData] = useState(userStorage)
    const [uuid, setUUID] = useState(null);
    const user = JSON.parse(storage.getItem(variables.USER));
    const [newMessage, setNewMessage] = useState("");
    const [value, setValue] = useState("TUTOR");
    const scrollRef = useRef();
    const [online, setOnline] = useState([]);
    const [uuidSender, setuuidSender] = useState(null);
    //Socket
    const socket = useRef();

    const onChangeR = (e) => {
        setValue(e.target.value);
    };


    const showDiff = (date) => {

        var duration = moment().diff(moment(date), 'days');
        if (moment(moment(date).format("YYYY-MM-DD")).isSame(moment().format("YYYY-MM-DD"))) {
            return moment(date).format("HH:mm")
        } else {
            if (duration < 5) {
                if (duration === 0) {
                    duration = 1;
                }
                return t("hace") + " " + duration + " " + (duration == 1 ? t("day") : t("days"));
            } else {
                return moment(date).format("DD/MM/YYYY hh:mm")
            }

        }
    }



    const getListChat = () => {
        xcService.getToken('/v1/student/comments')
            .then(({data}) => {


                setListChats(data.data ? data.data.reverse() : []);


                if (tutorSel){
                    let mTutorSel = data.data.filter(item => item.id === tutorSel)
                    if (mTutorSel && mTutorSel[0]){
                        chatSelected(mTutorSel[0])
                    }
                }

                socket.current = io(config.socketUrl);

                socket.current.on("getMessage", (data) => {
                    getChatSocket(data);
                });
                socket.current.emit("addUser", user.uuid ?? "master");
                socket.current.on("getUsers", (users) => {

                    setOnline(users)
                });
            })

    }

    const chatSelected = (item) => {

        setWriting(false);
        setTutorSel(false);
        setChatSel(item);
        setUUID(item.uuid)

        socket.current = io(config.socketUrl);

        socket.current.on("getMessage", (data) => {
            getChatSocket(data);

        });


        getMessages(item.id);
    }

    useEffect(() => {
        if (uuidSender){
            if (!chatSel){
                let mSel = listChats.filter(it => it.uuid === uuidSender);
                if (mSel && mSel[0]){
                    setChatSel(mSel[0]);
                    getMessages(mSel[0].id);
                    setuuidSender(null);
                }
            }else{
                getMessages(chatSel.id);
                setuuidSender(null);
            }


        }
    },[uuidSender])

    const getChatSocket =  (data) => {

        if (data.senderId){
            setuuidSender(data.senderId)
            setLastComment(data.text);
        }

    }
    const init = () => {
        getListChat();

        xcService.getToken('/v1/student/comments/tutors')
            .then(({data}) => {

                setTutors(data.data);
            })
    }
    useEffect(() => {
            init()

        },
        [])

    useEffect(() => {

    }, [])

    const onChange = (e) => {
        setNewMessage(e.target.value);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        sendChat(uuid);
    };


    const sendChat = (id) => {
        let payload = {
            sendTo: id,
            comment: newMessage,
            isTutor: chatSel.profile === "TUTOR" ? true : false
        };



        xcService.postToken('/v1/student/comments/new', payload)
            .then(({data}) => {
                socket.current.emit("sendMessage", {
                    receiverId: "A_" + chatSel.uuid,
                    senderId: user.uuid,
                    text: newMessage,
                });
                socket.current.emit("sendMessage", {
                    receiverId: chatSel.uuid,
                    senderId: user.uuid,
                    text: newMessage,
                });

                setNewMessage("")
                getListChat();
                if (chatSel){
                    getMessages(chatSel.id)
                }

            })


        //   dispatch(feedActions.saveChat(payload));
    };

    useEffect(() => {
        socket.current = io(config.socketUrl);
        return () => {
          
          socket.current.emit("removeUser", user.uuid);
        };
      }, []);


    const getMessages = (id) => {
        setLoading(true)
        setMessages([])
        xcService.getToken('/v1/student/comments/' + id)
            .then(({data}) => {
                setLoading(false);

                setMessages(data.data);
            }).catch(e =>  setLoading(false));
    }

    const onChangeTutor = (value) => {

        setTutorSel(value);
        let mTemp = tutors.filter(it => it.id === value);
        if (mTemp && mTemp[0]){
            setChatSel( mTemp[0]);
            setUUID(mTemp[0].uuid)
        }
    };

    const onSearchTutor = (value) => {
    };


    useEffect(() => {

        if (chatSel) {
            let scrollToBot = document.getElementById('content-chat');
            if (scrollToBot)
                scrollToBot.scrollTop = scrollToBot.scrollHeight;
        }

    }, [messages]);

    const getTutors = () => {

        if (value !== "1"){



                return tutors.filter(it => it.profile === value)



        }else{
            return tutors
        }

    }


    const isOnline = (item) => {
        try {

            let mUUID = "master";
                mUUID = item.uuid;


            let mEsta = online.filter((user) => user.userId === mUUID);
            return mEsta.length > 0 ;
        }catch (e){
            return false;
        }
    }

    const IconText = ({ icon, item }) => (
        <Popconfirm
            title={t("borrarmensaje")}
            description={t("borrarmensaje")}

            onConfirm={() => deleteMessage(item)}

            onCancel={cancel}
        ><Space>
            {React.createElement(icon)}
        </Space></Popconfirm>
    );


    const deleteMessage = (item) => {

        xcService.deleteToken("/v1/student/chat/" + item.id).then(data => {
            setChatSel(null);
            init();

        })
    }

    const cancel = (e) => {

    };

    const goWrite = () => {
        setWriting(true);
        setChatSel(null)
    }

    const getCAvatarName = (_avatar) => {
        if(isUUID(_avatar) ) return '-';
        return concatNameOrAnon(_avatar)
    }
    const getCName = (item) => {
        if(isUUID(item?.name) || isUUID(item?.surname)) {
            const date = moment(item?.createdAt).format("YYYY");
            return getNameByProfile( item?.profile, date);
        }
        return concatName(item?.name, item?.surname)
    }
    
    return (
        <>
            <div className={"container container--messages boxed boxed--admin-default"}>
                <div className={"content-messages-top"}>
                    <h1>{t("mensajes.title")}</h1>

                    <Button type="primary"
                            onClick={() => goWrite()}
                            size={'large'} shape="round" icon={<FormOutlined />}>{t("mensajes.redactar")}
                    </Button>
                </div>
                <p>{t("mensajes.descstudent")}</p>
                    <>

                        <div className={`content-messages-mid ${(chatSel || writing) && "is-select-chat"}`}>

                            <div className={"content-messages-left"}>

                                <List
                                    itemLayout="horizontal"
                                    dataSource={listChats}
                                    renderItem={(item) => (
                                        <List.Item
                                            onClick={(e) => {
                                                chatSelected(item)
                                            }}

                                          className={`preview-chat ${chatSel && item.id === chatSel.id ? "preview-chat--select" : "preview-chat--not-select"}`}
                                          >
                                            <div className={"preview-chat-top"} >
                                                {isOnline(item) ? <Badge color="green"  /> : <></>}
                                                {item?.avatar ? <Avatar className={"icon"} src={getCAvatarName(item?.avatar)}/> : <Avatar className={"icon"}>{getCAvatarName(item?.name)}</Avatar>}
                                                <div className={"name"}>{getCName(item)}</div>
                                                <div className={"data"}>{showDiff(item.createdAt)}</div>
                                            </div>
                                            {<div className={"preview-chat-bottom"}>
                                                {lastComment ? lastComment : item.comment}
                                            </div>}
                                        </List.Item>
                                    )}
                                />
                            </div>
                            <div className={"content-messages-right"}>
                                {!isBrowser &&
                                    <Button size={'large'} onClick={() => setChatSel(null)} type="primary" icon={<LeftOutlined /> }>
                                        {t("atras")}
                                    </Button>

                                }
                                {writing &&
                                    <>  <div><Radio.Group onChange={onChangeR} value={value}>
                                        <Radio value={"TUTOR"}>{t("solotutores")}</Radio>
                                        <Radio value={"COUNSELOR"}>{t("soloorientadores")}</Radio>
                                    </Radio.Group></div>
                                        <Select
                                            size={'large'}
                                            style={{ width: 360 }}
                                            showSearch
                                            placeholder={t("mensajes.para")}
                                            optionFilterProp="children"
                                            onChange={onChangeTutor}
                                            onSearch={onSearchTutor}
                                            filterOption={(input, option) => {

                                                let mSearch = input.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "")

                                                return (option?.label ?? '').toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)

                                            }
                                            }>
                                            {getTutors().map( tutor => {
                                              return <Option  key={tutor.id} value={tutor.id}
                                                              label={tutor.name + " " + tutor.surname}>{tutor.name} {tutor.surname +  " (" +(tutor.profile === "COUNSELOR" ? t("isOrientador") : t("isTutor")) + ")"}</Option>
                                            })
                                            }

                                        </Select>
                                        <div className="content-chat-box" style={{ marginTop: "16px" }}>
                                            <TextArea
                                                  className="chat-box-input"
                                                  style={{ resize: "none", height: "70px", padding: "12px 56px 4px 12px" }}
                                                  onChange={onChange} />
                                            <Button
                                                onClick={() => sendChat(uuid)}
                                                shape="circle"
                                                type="primary"
                                                size="large"
                                                icon={<SendOutlined/>}
                                            ></Button>
                                        </div>
                                    </>
                                }

                                {!writing && chatSel &&
                                    <>


                                        <div id={"content-chat"} className={"content-chat-messages"} >
                                            <Popconfirm
                                                title={t("borrarmensaje")}
                                                description={t("borrarmensaje")}

                                                onConfirm={() => deleteMessage(chatSel)}

                                                onCancel={cancel}
                                            >
                                                <Button style={{float: "right"}} size={'large'}  icon={<DeleteOutlined /> }>
                                                    {t("borrarc")}
                                                </Button></Popconfirm>
                                            {!loading ?
                                            <div className={"messages"} ref={scrollRef}>
                                                {messages.map(item => {
                                                    return <Message user={user} t={t} key={uuidv1()} item={item}/>
                                                })}
                                            </div>
                                            :
                                            <Spin indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />} />
                                            }
                                        </div>
                                        <div className="content-chat-box">
                                            <TextArea allowClear
                                                   value={newMessage}
                                                   className="chat-box-input"
                                                   placeholder={`${t("quedecir")}, ${user.name}?`}
                                                   onChange={onChange}
                                            />

                                            <Button
                                                onClick={(e) => handleSubmit(e)}
                                                shape="circle"
                                                type="primary"
                                                size="large"
                                                icon={<SendOutlined/>}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </>

            </div>
        </>)


}


export default withTranslation()(MessageUserView);
